export const employeesGridSwitch = {
    bindings: {
        identifier: '@'
    },
    template: require('./employees-grid-switch.html'),
    controller: 'EmployeesGridSwitchController'
};
